import React, {useEffect, useState} from 'react';
import { GlassMagnifier } from "@africasokoni/react-image-magnifiers";
import Typography from '@mui/material/Typography';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from "swiper";

import '../../styles/vehicle/vehiclePartConditionCarousel.css';

import "swiper/css";
import "swiper/css/navigation";

export function VehiclePartConditionCarousel({photoState}) {
    const totalCount = photoState.photos.length;
    const [activeIndex, setActiveIndex] = useState(1);
    const [bigSlider, setBigSlider] = useState({});
    const [thumbSlider, setThumbSlider] = useState({});
    
    const getWindowDimensions = function() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height
        };
    }

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    console.debug(windowDimensions.width);
    return (
        <>
            <Swiper
                onSlideChange={(e) => {
                    thumbSlider.slideTo(e.activeIndex);
                }}
                onInit={(e) => {
                    setBigSlider(e);
                }}
                spaceBetween={30}
                navigation={true} modules={[Navigation]}
                className="bigPhotosSlider"
            >
                {photoState.photos.map((x, idx) => (
                    <SwiperSlide key={`slide_${idx}`} style={{ width: '100%', height: '592px' }}>
                        <div
                            style={{ height: '548px', padding: '0 45px' }}
                            className='swiper-image-custom'>
                            <GlassMagnifier style={{ height: "548px" }}
                                            allowOverflow={false}
                                            height='548px'
                                            magnifierBorderSize={7}
                                            magnifierSize='35%'
                                            imageSrc={`https://shareapi.sam-performance.com/api/Share/Picture?subdomain=app&token=8bb0aacf-c62c-4be6-b92a-e3f18214676c&id=${x.id}`}/>
                        </div>
                        <p className="photo-description">{x.description}</p>
                        {!!x.date ? <p className="textcenter">Aufnahmedatum: <span>{x.date}</span></p> : ''}
                    </SwiperSlide>
                ))}
            </Swiper>

            <Swiper
                onSlideChange={(e) => {
                    setActiveIndex(e.activeIndex + 1);
                    bigSlider.slideTo(e.activeIndex);
                }}
                onInit={(e) => {
                    setThumbSlider(e);
                }}
                slidesPerView={windowDimensions.width < 600 ? 3 :windowDimensions.width < 900 ? 4 : windowDimensions.width < 1200 ? 6 : 9}
                spaceBetween={0}
                centeredSlides={true}
                shortSwipes={false}
                preventClicks={false}
                slideToClickedSlide={true}
                navigation={true} modules={[Navigation]}
                className="thumbSlider thumbsContainer"
            >
                {photoState.thumbnails.map((x, idx) => (
                    <SwiperSlide style={{width:'125px', marginLeft:'10px'}} key={`thumbslide_${idx}`}>
                        <div style={{width:'125px', height:'125px', cursor: 'pointer', border: '3px solid transparent'}}>
                            <img
                                style={{width:'125px', height:'125px', objectFit: 'cover'}}
                                className='swiper-lazy'
                                src={`data:image/png;base64,${x.thumbnailBase64}`}
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <Typography variant="subtitle1" sx={{mt: 3}} align="center" display="block" gutterBottom>
                {activeIndex} / {totalCount}
            </Typography>
        </>
    );
}